import { Trans } from 'react-i18next';
import HeaderSettingsTabs from './HeaderSettingsTabs';

import StyledHeaderSettings from '/business/shared/components/widgets/header/__styled__/StyledHeaderSettings';

function HeaderSettings() {
  return (
    <StyledHeaderSettings>
      <h1>
        {/* @i18n: Settings */}
        <Trans i18nKey="business:ApplicationSettings.title" />
      </h1>
      <HeaderSettingsTabs />
    </StyledHeaderSettings>
  );
}

export default HeaderSettings;
